/* RESPONSIBLE TEAM: team-reporting */

import Model, { attr } from '@ember-data/model';
import { type LogicalFilter } from 'embercom/components/reporting/custom/filters';

export interface DeliveryTime {
  hour: number;
  minute: number;
  timeZone: string;
}

export interface Interval {
  step: string;
  value: number;
  dayPosition?: '*' | 'first' | 'last';
}
export interface ExportRule {
  daysOfWeek: Array<number>;
  deliveryTime: DeliveryTime;
  interval: Interval;
}

export interface DatasetExportConfig {
  datasetId: string;
  sortByAttributeId: string;
  attributeIds: Array<string>;
  filter: LogicalFilter;
  dateRangeSelection: 'past_4_weeks';
}

function hashAttr(options?: { excludeKeys?: string[] }) {
  return attr('hash', options as any);
}

export default class DatasetExportSchedule extends Model {
  @attr('string') declare name: string;
  @hashAttr() declare exportRule: ExportRule;
  @hashAttr({ excludeKeys: ['filter'] }) declare exportConfig: DatasetExportConfig;
}
